export const GET_ALL_PROGRAMS = "GET_ALL_PROGRAMS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_PROGRAMS = "START_LOADING_PROGRAMS";
export const STOP_LOADING_PROGRAMS = "STOP_LOADING_PROGRAMS";
export const ERROR_LOADING_PROGRAMS = "ERROR_LOADING_PROGRAMS";